/**
 * The Squidler browser extension's ids (.plans/prd-browser-companion.md).
 *
 * Two things trust them, so they are code rather than env: the CSP is baked
 * into the build (next.config.ts — one artifact serves dev and prod), and the
 * connect page hands a device credential only to one of these ids. An id an
 * attacker controls in either list would let their extension frame the app or
 * receive a credential, so a change here is a security change.
 *
 * - amejpkieaedbcbebohplibidkceijpce — the unpacked/dev build. Fixed by the
 *   public `key` in apps/companion-extension/manifest.json; the private half is
 *   not in the repository and is not needed to load the extension unpacked.
 * - The Chrome Web Store id is added when the (unlisted) item exists.
 */
export const COMPANION_EXTENSION_IDS: readonly string[] = ["amejpkieaedbcbebohplibidkceijpce"];

export const isCompanionExtensionId = (id: string): boolean => COMPANION_EXTENSION_IDS.includes(id);

/** `chrome-extension://<id>` for each, as CSP sources. */
export const companionExtensionOrigins = (): string[] => COMPANION_EXTENSION_IDS.map((id) => `chrome-extension://${id}`);
